import { getProduct } from "apis/productApi";
import { getPdf } from "apis/unzipPdfApi";
import { doCall } from "common/genericSaga";
import { downloadBlob } from "helpers/urlHelper";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  PDF_EXISTS_REQUESTED,
  PDF_EXISTS_REQUEST_FAILED,
  receivePdfExists,
  receiveUnzippedPdf,
  UNZIP_PDF_REQUESTED,
  UNZIP_PDF_REQUEST_FAILED
} from "./unzipPdfActions";

export function* doRequestPdf(action, requestInfo) {
  const blob = yield call(getPdf, requestInfo, action.id);
  var url = yield call(downloadBlob, blob, `${action.id}.pdf`);
  yield put(receiveUnzippedPdf(action.id, { url }));
}

export function* doRequestPdfExists(action, requestInfo) {
  const product = yield call(getProduct, requestInfo, action.id);
  let result = false;
  for (let i = 0; i < product.files.length; i++) {
    const file = product.files[i];
    if (file.purpose === "product.pdf") {
      result = true;
      break;
    }
  }
  yield put(receivePdfExists(action.id, { result }));
}

export function* watchUnzipPdf() {
  yield all([
    takeLatest(UNZIP_PDF_REQUESTED, doCall(doRequestPdf, UNZIP_PDF_REQUEST_FAILED)),
    takeEvery(PDF_EXISTS_REQUESTED, doCall(doRequestPdfExists, PDF_EXISTS_REQUEST_FAILED))
  ]);
}
